import React, { FC, useRef, useState } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { dateCalendarFormatType, currentFormatTime, dateFormat } from 'src/utils/dateSet';
import { addComma } from 'src/utils/common';
import NoResult from 'src/components/molecules/table/NoResult';

interface Props {
  data: any;
  viewType?: string;
  modifyItemEvt: (item: any) => void;
  deleteItemEvt: (item: any) => void;
}
const GridList: FC<Props> = ({ data, viewType, modifyItemEvt, deleteItemEvt }) => {
  const viewData: any = data || [];
  const setData = [];
  const deleteEvt = (item: any) => {
    deleteItemEvt(item);
  };
  const modifyEvt = (item: any) => {
    modifyItemEvt(item);
  };

  const viewDataType = (item: any) => {
    let typeView = '';
    switch (item) {
      case 'K01':
        typeView = '소기업소상공인 공제부금';
        break;
      case 'X02':
        typeView = '우리사주출연금(일반)';
        break;
      case 'X03':
        typeView = '우리사주출연금(벤처기업 등)';
        break;
      case 'X01':
        typeView = '고용유지중소기업근로자';
        break;
      case 'N01':
        typeView = '장기집합투자증권저축';
        break;
      case 'N02':
        typeView = '청년형장기집합투자증권저축';
        break;
      case 'L01':
        typeView = '투자조합출자 - 조합1';
        break;
      case 'B01':
        typeView = '투자조합출자 - 벤처';
        break;
      case 'H01':
        typeView = '투자조합출자 - 조합2';
        break;
      default:
        typeView = '';
        break;
    }
    return typeView;
  };

  return (
    <div className="_table_grid_layout _housesave_list_grid">
      <div className="_grid">
        <div className="_label">
          <div className="_row _i_h3">
            {viewType === 'modify' ? (
              <>
                <div className="_col _wd_n01 _hd_n01">
                  <div className="_tit"></div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="_col _wd_n4">
              <div className="_cont">국세청 자료</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">유형</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">은행</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">투자년도</div>
            </div>
            <div className="_col _wd_n5">
              <div className="_cont">계정규칙적용여부 </div>
            </div>
            <div className="_col _wd_n5">
              <div className="_cont">법인대표자여부</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">금액(국세청)</div>
            </div>
            <div className="_col _wd_n3">
              <div className="_cont">금액(일반)</div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="_content">
          {viewData.map((item: any, idx: number) => {
            const infoData = item || {};

            return (
              <div className="_row _i_h2" key={idx}>
                {viewType === 'modify' ? (
                  <>
                    <div className="_col _wd_n01">
                      <div className="_cont">
                        <div className="_i_row ">
                          <div className="_i_col _w_p_50  _bor_r">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => modifyEvt(item)}
                                icon="ri-edit-box-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                          <div className="_i_col _w_p_50">
                            <div className="_btn">
                              <IconButton
                                clickEvent={e => deleteEvt(item)}
                                icon="ri-delete-bin-2-line"
                                status=""
                                type="type2"
                                styleDef={{
                                  width: '22px',
                                  height: '22px',
                                  border: '0px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
                <div className="_col _wd_n4">
                  <div className="_cont">{infoData.is_htx_pdf === 'Y' ? '국세청제공' : '-'}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{viewDataType(infoData.data_type)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{infoData.bank_cd}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{infoData.invest_year}</div>
                </div>
                <div className="_col _wd_n5">
                  <div className="_cont">{infoData.is_revision_rule}</div>
                </div>
                <div className="_col _wd_n5">
                  <div className="_cont">{infoData.is_co_rep}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{addComma(infoData.htx_amt)}</div>
                </div>
                <div className="_col _wd_n3">
                  <div className="_cont">{addComma(infoData.amt)}</div>
                </div>
              </div>
            );
          })}
          {viewData.length === 0 ? <NoResult /> : ''}
        </div>
      </div>
    </div>
  );
};

export default GridList;
